import { render, staticRenderFns } from "./QrCodeTester.vue?vue&type=template&id=0b2a6dca&scoped=true"
import script from "./QrCodeTester.vue?vue&type=script&setup=true&lang=ts"
export * from "./QrCodeTester.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./QrCodeTester.vue?vue&type=style&index=0&id=0b2a6dca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2a6dca",
  null
  
)

export default component.exports